
import React from 'react';
import { Camera, Box, Origami, Settings, Paintbrush } from 'lucide-react';
import { ImageType } from '../TypeFilter';
import { useIsMobile } from '@/hooks/layout/use-mobile';
import { StylishSelector } from '@/components/checkboxes/StylishSelector';

interface TypeSelectorProps {
  selectedType: ImageType | null;
  onTypeChange: (type: ImageType | null) => void;
}

const TypeSelector: React.FC<TypeSelectorProps> = ({ selectedType, onTypeChange }) => {
  const { isMobile } = useIsMobile();

  // Image type options with icons
  const imageTypeOptions = [
    { id: 'Photo', name: 'Photo', icon: Camera },
    { id: 'Anime', name: 'Anime', icon: Origami },
    { id: 'Art', name: 'Art', icon: Paintbrush },
    { id: '3D', name: '3D', icon: Box }
  ];

  // Use blue for all image type buttons
  const colorVariant = 'blue';

  // Handle type selection with toggle functionality
  const handleTypeSelect = (type: string) => {
    // Toggle functionality: if clicking the already selected type, deselect it
    if (selectedType === type) {
      // Deselect the current type by setting it to null
      onTypeChange(null);
    } else {
      // Select the new type
      onTypeChange(type as ImageType);
    }
  };

  return (
    <div>
      <StylishSelector
        styles={imageTypeOptions}
        selectedStyle={selectedType || ''} // Convert null to empty string for StylishSelector
        onSelectStyle={handleTypeSelect}
        className="grid-cols-2 gap-4"
        colorVariant={colorVariant}
        checkColor="blue-500"
      />
    </div>
  );
};

export default TypeSelector;
